<template>
  <div id="custom-online">
    <Breadcrumb></Breadcrumb>
    <div class="form-body">
      <el-form label-width="80px" ref="form" :model="queryParams">
        <el-row :gutter="24">
          <el-col :span="8">
            <el-form-item prop="bottomId" label="申请编号：" class="hide_input">
              <el-input
                size="small"
                v-model="queryParams.bottomId"
                placeholder="请输入内容"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item prop="bottomStatus" label="状态：" class="hide_input">
              <el-select
                clearable
                v-model="queryParams.bottomStatus"
                placeholder="请选择状态"
                class="input"
                size="small"
              >
                <el-option
                  v-for="(value, index) in dictData['bottomStatus']"
                  :key="index"
                  :label="value.label"
                  :value="value.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item style="text-align:right;">
              <el-button size="small" type="primary" @click="getList"
                >搜索</el-button
              >
              <el-button size="small" @click="resetForm">重置</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div class="table-body">
      <el-row>
        <el-col :span="8">
          <el-button @click="handleBuyModel" size="small" type="primary"
            >新增底板购买</el-button
          >
        </el-col>
        <el-col
          :span="16"
          style="text-align: right;height:36px;line-height:36px;"
        >
          <pagination
            v-show="total > 0"
            :total="total"
            :page.sync="queryParams.pageNum"
            :limit.sync="queryParams.pageSize"
            @pagination="getList"
          />
        </el-col>
      </el-row>
      <div>
        <el-row style="display: flex;flex-wrap: wrap;background-color: white">
          <el-col
            :span="12"
            style="display: flex;padding-left: 20px;color: #333333;font-size:14px;align-items: center"
          >
            <div v-if="rowSelectNum > 0">已选中{{ rowSelectNum }}条数据</div>
          </el-col>
          <el-col :span="12"> </el-col>
        </el-row>
        <el-table ref="table" :data="tableData" class="clain-tab" border>
          <el-table-column
            label="申请编号"
            width="169px"
            align="center"
            prop="bottomId"
          >
            <template slot-scope="scope">
              <span
                @click="handleViewBottom(scope.row)"
                class="el-button--text"
                style="cursor: pointer;"
                >{{ scope.row.bottomId }}</span
              >
            </template>
          </el-table-column>
          <el-table-column label="产品名称" align="center" prop="proName">
            <template slot-scope="scope">
              <span
                @click="handleJumpProduct(scope.row)"
                class="el-button--text"
                style="cursor: pointer;"
                >{{ scope.row.proName }}</span
              >
            </template>
          </el-table-column>
          <el-table-column
            v-if="user.userType == '00'"
            label="主账号"
            width="169px"
            align="center"
            prop="poperNo"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.poperNo }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="申请人"
            width="169px"
            align="center"
            prop="operNo"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.operNo }}</span>
            </template>
          </el-table-column>

          <el-table-column
            label="申请时间"
            align="center"
              width="199px"
            prop="createTime"
          ></el-table-column>
          <el-table-column  width="160" label="状态" align="center" prop="bottomStatus">
            <template slot-scope="scope">
              <span>{{ dictMap["bottomStatus"][scope.row.bottomStatus] }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="操作"
            prop="hand"
            width="160"
            header-align="center"
            align="center"
          >
            <template slot-scope="scope">
              <el-button
                type="text"
                size="small"
                v-if="scope.row.bottomStatus == '01' && user.userType == '00'"
                @click="handleReview(scope.row)"
                >审核</el-button
              ><br
                v-if="scope.row.bottomStatus == '01' && user.userType == '00'"
              />
              <el-button
                type="text"
                size="small"
                v-if="scope.row.bottomStatus == '01' && user.userType !== '00'"
                @click="handleShowEdit(scope.row)"
                >修改</el-button
              ><br
                v-if="scope.row.bottomStatus == '01' && user.userType !== '00'"
              />
              <el-button
                v-if="scope.row.bottomStatus == '01' && user.userType !== '00'"
                type="text"
                size="small"
                @click="handleDelete(scope.row)"
                >取消</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <pagination
          v-show="total > 0"
          :total="total"
          :page.sync="queryParams.pageNum"
          :limit.sync="queryParams.pageSize"
          @pagination="getList"
        />
      </div>
    </div>
    <el-dialog
      :close-on-click-modal="false"
      title="编辑"
      width="800px"
      class="common-limit"
      :destroy-on-close="true"
      :visible.sync="editVisible"
    >
      <div style="height: 460px;overflow-y: auto;overflow-x: hidden;">
        <div v-for="(record, index) in cartArray" :key="index">
          <div class="product-title">{{ record.proName }}</div>
          <el-form ref="form" label-width="80px">
            <el-row :gutter="24">
              <el-col :span="9">
                <div
                  style="border: 1px solid #e3e3e3;width:180px;height: 180px;padding:5px;"
                >
                  <img
                    :src="
                      `${record.currentSku.mainPic.picUrl}?x-oss-process=image/resize,m_fill,h_200,w_200`
                    "
                    width="180"
                    height="180"
                    alt=""
                  />
                </div>
                <div>
                  <div style="margin-top:0;" class="sku-attr">
                    <div class="sku-name">颜色</div>
                    <div class="sku-detail">
                      <a
                        class="sku-color"
                        v-for="(color, index) in record.attribute['颜色']"
                        :key="index"
                        >{{ color }}</a
                      >
                    </div>
                  </div>
                  <div style="margin-top:0;" class="sku-attr">
                    <div class="sku-name">尺码</div>
                    <div class="sku-detail">
                      <a
                        class="sku-size"
                        v-for="(size, index) in record.attribute['尺码']"
                        :key="index"
                        >{{ size }}</a
                      >
                    </div>
                  </div>
                </div>
              </el-col>
              <el-col :span="15">
                <div class="sku-attr">
                  <div class="sku-name">成品编号：</div>
                  <div class="sku-detail" style="margin: 0;width: 330px;">
                    {{ record.designId }}
                    <el-button
                      style="margin: 0 0 0 16px;"
                      @click="handleSetParent(record)"
                      v-if="record.designId !== record.groupDesignId"
                      size="small"
                      type="primary"
                      >设为母体</el-button
                    ><span style="color: #409eff;margin: 0 0 0 16px;" v-else
                      >已设置为母体</span
                    >
                  </div>
                </div>
                <div class="sku-attr">
                  <div class="sku-name">设计后中文名称：</div>
                  <div class="sku-detail" style="margin: 0;width: 330px;">
                    <el-input v-model="record.proName" size="small"></el-input>
                  </div>
                </div>
                <div class="sku-attr">
                  <div class="sku-name">设计后英文名称：</div>
                  <div class="sku-detail" style="margin: 0;width: 330px;">
                    <el-input
                      v-model="record.engProName"
                      size="small"
                    ></el-input>
                  </div>
                </div>
                <div class="sku-attr">
                  <div
                    class="sku-detail"
                    style="margin: 0;width: 330px;margin: 0 0 0 109px;"
                  >
                    <el-button
                      @click="handleModifyDesign(record)"
                      size="small"
                      type="primary"
                      >保存</el-button
                    >
                    <el-button
                      v-if="false"
                      @click="handleEditDesign(record)"
                      size="small"
                      type="primary"
                      >修改设计</el-button
                    >
                    <el-button
                      v-if="false"
                      @click="handleReDesign(record)"
                      size="small"
                      type="primary"
                      >重新设计</el-button
                    >
                  </div>
                </div>
              </el-col>
            </el-row>
          </el-form>
        </div>
      </div>
      <div slot="footer">
        <el-button @click="editVisible = false" size="small" type="primary"
          >确定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script type="text/ecmascript-6">
import Breadcrumb from '@/components/common/Breadcrumb'
import {listBottom, updateBottom} from '@/api/customProduct/bottom'
import {mapGetters} from 'vuex'
import {addCart, addOrEdit} from '@/api/order/cart'
import {getDesignSku} from '@/api/customProduct/designSku'
import {getAllShop} from "@/api/plat/platType";
import {moveToRelease} from "@/api/customProduct/custom";
import {addToShoppingCart} from'@/api/customProduct/custom'
import CKEditor4 from '@/components/common/CKEditor'

export default {
    name: "product",
    components:{Breadcrumb, CKEditor4},
    data(){
        return{
            // 遮罩层
            loading: true,
            closeDelay:0,
            total:0,
            queryParams:{
                pageNum: 1,
                pageSize: 30,
                bottomId: null,
                bottomStatus: null,
            },
            pickerOptions: {
                disabledDate(time) {
                    return time.getTime() > Date.now();
                },
            },
            groupTypeArray: [
              {label : '多素材组合' ,value: '01'},
               {label : '单元素组合' ,value: '02'},
                {label : '简单商品' ,value: '03'},

            ],
            attribute: {},
            currentAttr: {
              color: "",
              size: "",
            },
            currentSku: {},
            mainPic: '',
            productNum: 1,
            tableData:[],
            detailData: [],
            cartArray: [],
            claimCollIds:[],////选中 的产品id
            cartDialogVisible: false,
            cartData: [],
            commodity: {},
            totalCount: 0,
            totalNum: 0.00,
            totalPrice: 0.00,

            /*临时字段区--用于记录*/
            lastId: "",
            platList:[],
            shopSelectDialog:false,
            shopList:[],
            checkAll: false,
            checkedShops: [],
            checkPlat:undefined,
            isIndeterminate: true,
            currentRow:null,
            /* 新增的修改需求用到的字段 */
            colors: [],
            sizes: [],
            form: {},
            singlePrice: '',
            editVisible: false,
            detailVisible: false,
            detailInfo: {},
            editor: null,
            editorConfig:{
              allowedContent: true,//设置为true，以防止CKEditor 4删除不允许的元素
              extraPlugins:['uploadImg'],
              height:'300px',
              toolbar : [
                  [ 'Maximize'],
                  [ 'Bold', 'Italic', 'Underline', 'Strike'],
                  [ 'TextColor', 'BGColor' ],
                  [  'JustifyLeft', 'JustifyCenter', 'JustifyRight', 'JustifyBlock','-','NumberedList', 'BulletedList', '-', 'Outdent', 'Indent',  '-','Subscript', 'Superscript'],
                  [ 'HorizontalRule','RemoveFormat'],
                  [ 'Undo', 'Redo' ],
                  '/',
                  [ 'Styles', 'Format', 'Font', 'FontSize' ],
                  [ 'Table'],
                  [ 'uploadImg']
              ],
              language: 'zh-cn',
              wordcount:{
                  showCharCount: true,
              }
            },
        }
    },

    computed:{
        rowSelectNum(){
            return this.claimCollIds.length;
        },

        ...mapGetters(['nginx','dictData', 'dictMap', 'user']),

    },
    watch:{
        shopSelectDialog(val, oldVal){
            if(!val){
                this.checkedShops = [];
            }
        }
    },
    created() {
        this.getList();
        this.initPlatData();
    },
    methods:{
      handleBuyModel(){
        let path = this.user.userType == '00' ? '/business/sellers/bottomDetail' : '/select/selection/addModel'
        this.$router.push({path: path})
      },
      handleJumpProduct(row){
        let routeUrl = this.$router.resolve({ path: "/select/custom/product", query: { pId: row.pId }} );
        window.open(routeUrl.href, '_blank');
      },
      async  handleJumpDesign(row){
        if(row.groupType == '01'){
          let result = await listGroup({groupDesignId: row.groupDesignId})
          this.detailData = result.rows
          this.detailVisible = true
        }else{
          let routeUrl = this.$router.resolve({ path: "/select/custom/product", query: { designId: row.designId }} );
          window.open(routeUrl.href, '_blank');
        }
      },
      handleJumpDetailDesign(designId){
        let routeUrl = this.$router.resolve({ path: "/select/custom/product", query: { designId: designId }} );
        window.open(routeUrl.href, '_blank');
      },
      handleJumpDetailProduct(pId){
        let routeUrl = this.$router.resolve({ path: "/select/custom/product", query: { pId: pId }} );
        window.open(routeUrl.href, '_blank');
      },
      handleJump(path){
        this.$router.push({path: path})
      },

      // table数据
      getList(){
            this.startLoading()
            let params = this._.clone(this.queryParams)
            if(params.timeRange){
              params.beginTime = params.timeRange[0]
              params.endTime = params.timeRange[1]
            }
            delete params["timeRange"]
            listBottom(params).then((re) => {
                this.tableData = re.rows;
                this.total = re.total;
                this.endLoading()
            }).catch(err =>{this.endLoading()});
      },
      async  handleNotGroup(row){
        try {
            this.$confirm('请确认是否取消组合商品', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
            }).then(async () => {
              let result = await cancelGroup({groupDesignId: row.designId})
              this.msgSuccess('取消组合成功')
              this.getList()
            }).catch(() => {
              this.$message({
                type: 'info',
                message: '已取消'
              });
            });

        } catch (error) {

        }
        },
        resetForm(){
          this.queryParams.productType = null
          this.queryParams.remitFlag = null
          this.queryParams.timeRange = []
          let params =  {
              timeRange: null,
              designId: null,
              designProName: null,
              proName: null,
              productType: null,
              operNo: null,
              remitFlag: null,
              beginTime: null,
              endTime: null,
              delFlag: '1'
          }
          this.$refs['form'].resetFields();
        },
        tableSelectionChange(val){
            this.claimCollIds = [];
            val.forEach(r =>{
                this.claimCollIds.push(r.designId)
            });

        },

        /*跳到我的详情*/
        showDetail(row){
            this.$router.push({path:'/carry/proCustom/particulars', query: row})
        },

        /*点击加入购物车*/
        async handleShowCart(row) {
          try {
            let cartData = await getCartInfo(row.designId)
            cartData.data.map(record=>{
              record.productNum = 1
              record.currentSku = record.skuList[0]
              record.attribute = JSON.parse(record.attribute)
              record.currentAttr = {color : '', size: ''}
              let properVal = record.skuList[0].properVal.split(":")
              // record.currentAttr.color = properVal[0]
              // record.currentAttr.size = properVal[1]
              // record.currentAttr
            })
            this.cartArray = cartData.data

            // this.currentSku = cartData.data.skuList[0]
            // this.mainPic = this.currentSku.picList[0].picUrl
            this.cartDialogVisible = true
          } catch (error) {
          }
        },
          /*编辑设计*/
        async handleShowEdit(row) {
          let path = this.user.userType == '00' ? '/service/manage/bottomDetail' : '/select/selection/addModel'
          this.$router.push({path: path, query: {
            bottomId: row.bottomId,
            type: 'edit'
          }})
        },
        handleReview(row){
          let path = this.user.userType == '00' ? '/service/manage/bottomDetail' : '/select/selection/addModel'
          this.$router.push({path: path, query: {
            bottomId: row.bottomId,
            type: 'review'
          }})
        },
        handleSetParent(row){
           setGroupMain({designId: row.designId ,groupDesignId: row.groupDesignId}).then(re => {
              this.$message({
                  type: 'success',
                  message: '保存成功'
              });
              for(let record of this.cartArray){
                record.groupDesignId = row.designId
              }
              this.getList()
          }).catch(err =>{

          });
        },
        handleSaveDesign(){
          this.detailInfo.remarks = this.editor.getData()
          updateDesign(this.detailInfo).then(re => {
              this.$message({
                  type: 'success',
                  message: '保存成功'
              });
              this.editVisible = false;
          }).catch(err =>{

          });
        },


        /*确认加入购物车*/
        confirmAddCart() {
            if (this.totalCount == 0) {
                this.$message({
                    message: '请至少添加一件!',
                    type: 'warning'
                });
            } else {
                this.cartDialogVisible = false;
                let i = 0;
                this.cartData.forEach(item =>{
                    i++;
                    if (item.count != 0) {
                        let params ={
                            designId:item.designId,//商品id
                            operNo:this.$store.state.user.name,//操作人
                            properName:'颜色:尺码',
                            properVal:item.color +":"+ item.size,
                            num:item.count,//商品数量
                            price:item.price,//商品价格
                            skuId:item.skuId,
                            selfType:'01',
                        }
                        addToShoppingCart(params); //创建购物车
                    }
                    if (this.cartData.length==i)
                        this.$message({message: "加入购物车成功", type:"success", duration: 700});
                });
                this.lastId = "";
                this.totalCount=0;
                this.totalNum=0.00;
                this.totalPrice=0.00;
            }
        },

        /*购物车弹框的计数*/
        getTotalCount(val1,obj){
            let count = 0; let price = 0.00;
            this.cartData.forEach(item =>{
                if(item.count != 0){
                    count += item.count;
                    price += item.price * item.count;
                }
            })
            this.totalCount = count;
            if (count == 0) {
                this.totalNum = 0.00;
            } else {
                this.totalNum = (price/count).toFixed(2);
            }
            this.totalPrice = price.toFixed(2);
        },

        /*通过商品id获取skuList*/
        getSkuList(designId) {
            if (this.lastId != designId) {
                this.lastId = designId;
                this.totalCount=0;
                this.totalNum=0.00;
                this.totalPrice=0.00;
                getDesignSku(designId).then((re) => {
                  let cacheColor = [];
                  let cacheSize = [];
                  let colors = [];
                  let sizes = [];
                    this.cartData = re.data;
                    re.data.forEach(e => {
                      if (cacheColor.indexOf(e.color) < 0) {
                        cacheColor.push(e.color);
                        colors.push(e);
                      }
                      if (cacheSize.indexOf(e.size) < 0) {
                        cacheSize.push(e.size);
                        sizes.push(e)
                      }
                      });
                    this.colors = colors;
                    this.sizes = sizes;

                })
            }
            this.cartDialogVisible = true;
        },

        handleCommand(val){
            if(this.claimCollIds.length==0){
                this.$message('请选择批量操作的数据！');
                return
            }
        },

        /*添加/修改备注*/
        addRemark(index) {
            let remark = this.tableData[index].remark;
            this.$prompt('请输入备注', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                inputValue: remark,
                // inputPattern: /[\w!#$%&'*+/=?^_`{|}~-]+(?:\.[\w!#$%&'*+/=?^_`{|}~-]+)*@(?:[\w](?:[\w-]*[\w])?\.)+[\w](?:[\w-]*[\w])?/,
                // inputErrorMessage: '格式不正确'
            }).then(({ value }) => {
                if (remark != value) {
                    this.tableData[index].remark = value;
                    updateDesign(this.tableData[index]).then(re => {
                        this.$message({
                            type: 'success',
                            message: '修改成功! 新备注是: ' + value
                        });
                    }).catch(err =>{

                    });
                }
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '取消输入'
                });
            });
        },

        //获取店铺数据
        async initPlatData(){
            let platDict;
            await this.getDicts("s_plat_code").then(res => {
                platDict = res.data;
            });
            let platCode = JSON.parse(JSON.stringify(this.$store.state.product.amazon.shopList));
            //获取所有平台代码
            let data = [];
            platDict.forEach(dict => {
                let map ={};
                map.platNo = dict.dictValue;
                map.platName = dict.dictLabel;
                map.shopList = [];
                platCode.forEach(code =>{
                    if(dict.dictValue == code.platNo){
                        map.shopList.push(code)
                    }
                });
                data.push(map);
            });
            this.platList = data.filter(item => {return item.shopList.length > 0});
        },
        platSelect(val,row){
            let shopList = this.platList.filter(plat =>{
                return plat.platNo == val;
            });
            this.shopSelectDialog = true;
            this.shopList = shopList[0].shopList;
            this.currentRow = row;
            this.checkPlat = val;
        },
        // 删除当前设计
        handleDelete(row) {
          this.$confirm('是否确认取消底板申请', "警告", {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning"
          }).then(async () => {
            await updateBottom({
              bottomId: row.bottomId,
              bottomStatus: '03'
            })
            this.msgSuccess("取消成功");
            this.getList()
          }).catch(function() {});
        },
        handleViewBottom(row){
          let path = this.user.userType == '00' ? '/business/sellers/bottomDetail' : '/select/selection/addModel'
          this.$router.push({path: path, query: {
            bottomId: row.bottomId,
            type: 'view'
          }})
        },
        handleEditDesign(row) {
          window.open('/design/online/designer?designId=' + row.designId)
        },
        handleReDesign(row) {
          window.open('/design/online/designer?pId=' + row.pId)
        },
        getEditor(editor){
            this.editor = editor;
        },
        handleSelectColor(record,color) {
          record.currentAttr.color = color
          this.selectSku(record)
        },
        handleSelectSize(record,size ) {
          record.currentAttr.size = size
          this.selectSku(record)
        },
        selectSku(product) {
          for (let record of product.skuList) {
            record.properVal = record.properVal.replace(/\\/g, "")
            if (
              record.properVal ===
              `${product.currentAttr.color}:${product.currentAttr.size}`
            ) {
              product.currentSku = record
              product.shop = true
              break
            }
          }
        },
         handleJumpProduct(row) {
          let routeUrl = this.$router.resolve({
            path: "/select/custom/product",
            query: { pId: row.pId },
          })
          window.open(routeUrl.href, "_blank")
        },
    }
}
</script>

<style lang="scss" scoped>
.searchBox {
  margin-top: 1.5%;
  border: 1px solid #d7d7d7;
}

.clain-tab {
  min-width: 1200px;

  .img-small {
    width: 100px;
    height: 100px;
    margin: 0 auto;
    border: 1px solid #ccc;
    padding: 1px;
  }
}

.el-table >>> .cell {
  max-height: 120px;
  line-height: 25px !important;
}

.el-dialog__wrapper >>> .el-dialog {
  width: 20%;
}

.cartType .el-row {
  padding: 3% 0px;
  border-bottom: 1px dashed #88888847;
  text-align: center;
}

.cart-but {
  background: #ff5561;
  width: 95%;
  height: 36px;
  font-size: 18px;
  color: white;
  margin-bottom: 2%;
  margin-left: 2%;
  line-height: 0;
}
.wrapper {
  margin-bottom: 5px;
}
.color-wrapper {
}
.color-wrapper .color-item {
  height: 40px;
  display: inline-block;
  margin-left: 5px;
  padding: 1px;
  border: 1px solid #e3e3e3;
  cursor: pointer;
}
.size-wrapper {
}
.product-title {
  font-size: 14px;
  margin: 0 0 8px 0;
}
.size-wrapper .size-item {
  display: inline-block;
  margin-bottom: 5px;
  margin-left: 5px;
  padding: 1px 15px;
  border: 1px solid #f0f0f0;
  background: #f0f0f0;
  cursor: pointer;
}
.price-wrapper {
  color: #428bca;
}
.price-wrapper .price {
  font-size: 20px;
  font-weight: 800;
}
.sku-attr {
  overflow: hidden;
  margin-top: 15px;
  padding: 0 0 0 8px;
  .sku-name {
    margin: 0 14px 0 0;
    float: left;
    line-height: 39px;
  }
  .sku-detail {
    float: left;
    margin: 5px 0 0 0;
  }
  .sku-detail {
    width: calc(100% - 58px);
    line-height: 39px;
  }
}
.sku-color {
  margin: 0 8px 0 0;
  padding: 4px;
  border: 1px solid #aaaaaa;
  cursor: pointer;
}
.sku-size {
  margin: 0 8px 0 0;
  padding: 4px 8px;
  border: 1px solid #aaaaaa;
  cursor: pointer;
  display: inline-block;
  line-height: 16px;
}
.is-select {
  border: 2px solid #0099e1;
}
.sku-price {
  font-size: 20px;
}
.templateName {
  cursor: pointer;
}
</style>
